import React, { useCallback, useEffect, useState } from 'react';

import { setShowOtpSuccessPopup } from 'actions/other';
import { resendPhoneNumberOTP, addPhoneNumber, verifyMobileNumber } from 'actions/user';
import { countryCode } from 'components/Auth/Signup/constants';
import AddMobileNumberModal from 'components/user_profile/addMobileNumberModal';
import { useAppDispatch, useAppSelector } from 'hooks';
import useKYC from 'hooks/useKYC';
import { userSelector, showOtpSuccessPopupSelector } from 'selectors';

const AddPhoneNumberModal = () => {
  const modalOpen = useAppSelector(showOtpSuccessPopupSelector);

  const [phoneNumber, setPhoneNumber] = useState('');

  const user = useAppSelector(userSelector);
  const { country, phone_number: phone } = user;
  const dispatch = useAppDispatch();

  const isdCode = countryCode[country!];

  const { isPhoneVerified: isPhoneNumberVerified } = useKYC();

  const setInitialValues = useCallback(() => {
    setPhoneNumber(isPhoneNumberVerified && phone ? phone : '');
  }, [phone, isPhoneNumberVerified]);

  useEffect(() => {
    setInitialValues();
  }, [setInitialValues]);

  const closeModal = () => {
    setPhoneNumber('');
    dispatch(setShowOtpSuccessPopup(false));
  };
  return (
    <AddMobileNumberModal
      open={modalOpen}
      value={phoneNumber}
      closeModal={closeModal}
      isdCode={isdCode}
      addPhoneNumber={payload => dispatch(addPhoneNumber(payload))}
      resendPhoneNumberOTP={payload => dispatch(resendPhoneNumberOTP(payload))}
      verifyMobileNumber={payload => dispatch(verifyMobileNumber(payload))}
    />
  );
};

export default AddPhoneNumberModal;
